import "./headerDesign.css";

function HeaderComp() {
  return <h1 id="topTitle">Course Helper</h1>;
}

export default HeaderComp;
